export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const CHECKPOST = 'CHECKPOST';
export const CHECKPOST_SUCCESS = 'CHECKPOST_SUCCESS';
export const CHECKPOST_FAIL = 'CHECKPOST_FAIL';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';

export const CHANGE_ACCESSTOKEN = 'CHANGE_ACCESSTOKEN';

export const CHECK_ACCESSTOKEN = 'CHECK_ACCESSTOKEN';
export const CHECK_ACCESSTOKEN_SUCCESS = 'CHECK_ACCESSTOKEN_SUCCESS';
export const CHECK_ACCESSTOKEN_FAIL = 'CHECK_ACCESSTOKEN_FAIL';

export const SET_ACCESSTOKEN_COOKIE = 'SET_ACCESSTOKEN_COOKIE';
export const SET_ACCESSTOKEN_COOKIE_SUCCESS = 'SET_ACCESSTOKEN_COOKIE_SUCCESS';
export const SET_ACCESSTOKEN_COOKIE_FAIL = 'SET_ACCESSTOKEN_COOKIE_FAIL';

export const GET_LIST_ROLERULE = 'GET_LIST_ROLERULE';
export const GET_LIST_ROLERULE_SUCCESS = 'GET_LIST_ROLERULE_SUCCESS';
export const GET_LIST_ROLERULE_FAIL = 'GET_LIST_ROLERULE_FAIL';

export const LOADING = 'LOADING';
export const SET_USER_INFO = 'SET_USER_INFO';
